import { render } from "./Reminder.vue?vue&type=template&id=f81e127e&scoped=true&ts=true"
import script from "./Reminder.vue?vue&type=script&lang=ts"
export * from "./Reminder.vue?vue&type=script&lang=ts"

import "./Reminder.vue?vue&type=style&index=0&id=f81e127e&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81e127e"]])

export default __exports__